import { Modal, Table } from 'antd';
import { ColumnsType, TableProps } from 'antd/lib/table';
import filesize from 'filesize';
import React, { ReactElement, ReactNode } from 'react';
import IApplicationEmailAttachment from '~Api/ApplicationEmail/IApplicationEmailAttachment';
import './emails.less';

export default function AttachmentsModal(props: {
    attachments: IApplicationEmailAttachment[];
    isOpen: boolean;
    onCancel: () => void;
}): ReactElement {
    const { attachments, isOpen, onCancel } = props;

    const columns: ColumnsType<IApplicationEmailAttachment> = [
        {
            key: 'filename',
            render: (attachment: IApplicationEmailAttachment): ReactNode => (
                <a
                    href={`${process.env.API_HOST}/application-email-attachments/${attachment.uuid}/download`}
                    rel='noopener noreferrer'
                    target='_blank'
                >
                    {attachment.filename}
                </a>
            ),
            title: 'Filename',
        },
        {
            key: 'size',
            render: (attachment: IApplicationEmailAttachment): ReactNode => filesize(attachment.bytes, {
                base: 2,
                round: 1,
                standard: 'jedec',
            }),
            title: 'Size',
            width: 110,
        },
    ];
    const scroll: TableProps<IApplicationEmailAttachment>['scroll'] = { y: 400 };

    return (
        <Modal
            className='application-emails-attachments-modal'
            footer={false}
            onCancel={onCancel}
            open={isOpen}
            title='Attachments'
            width={760}
        >
            <Table
                columns={columns}
                dataSource={attachments}
                pagination={false}
                rowKey='uuid'
                scroll={scroll}
                size='small'
            />
        </Modal>
    );
}
